import { GzExchangeContentControlContentFilteringRulesFormWebComponent } from './component/GzExchangeContentControlContentFilteringRulesFormWebComponent';

export { GzExchangeContentControlContentFilteringRulesFormWebComponent };
